import { routingPath } from 'app/routes';
import { useAuthContext } from 'modules/auth/context';
import { Navigate } from 'react-router-dom';
import { AuthContainerWrapper } from './styles';
import { ReactNode } from 'react';

export interface IAuthContainerProps {
  children: ReactNode;
}

const AuthContainer = ({ children }: IAuthContainerProps) => {
  const { isLogged } = useAuthContext();

  if (isLogged) {
    return <Navigate to={`/${routingPath.products.base}`} />;
  }

  return <AuthContainerWrapper>{children}</AuthContainerWrapper>;
};

export default AuthContainer;
